import { BrowserRouter, Route, Routes } from 'react-router-dom';
import "./fontawesome";
import SignIn from './components/auth/login';
import { Home } from './components/Home';
import { RequireAuth } from './components/utils/RequireAuth';
import { lazy, Suspense } from 'react';
import Loading from './components/layout/loading';
import { FlashAlert } from './components/utils/alerts';
import { Error404 } from './components/errors';
import { Category } from './components/category';
import Setup from './components/company/setup';
// import LoadingDisplay from './components/utils/alerts/loading-display';

const PageContainer = lazy(() => import("./components/layout/container"));
//profile
const Profile = lazy(() => import('./components/user/profile'));
//file-manager
const FileManager = lazy(() => import('./components/file-manager/manager'));
//profile
const PList = lazy(() => import("./components/profile/list"));
const PView = lazy(() => import("./components/profile/view"));
const PCreate = lazy(() => import("./components/profile/create"));
const PEdit = lazy(() => import("./components/profile/edit"));
//Coy
const CoyList = lazy(() => import("./components/company/list"));
const CoyView = lazy(() => import("./components/company/view"));
const CoyCreate = lazy(() => import("./components/company/create"));
const CoyEdit = lazy(() => import("./components/company/edit"));
//settings
const Settings = lazy(() => import("./components/company/settings"));
//outlet
const OLList = lazy(() => import("./components/outlet/list"));
const OLView = lazy(() => import("./components/outlet/view"));
const OLCreate = lazy(() => import("./components/outlet/create"));
const OLEdit = lazy(() => import("./components/outlet/edit"));
//user
const UList = lazy(() => import("./components/user/list"));
const UView = lazy(() => import("./components/user/view"));
const UCreate = lazy(() => import("./components/user/create"));
const UEdit = lazy(() => import("./components/user/edit"));
//user-group
const UGList = lazy(() => import("./components/user_group/list"));
const UGView = lazy(() => import("./components/user_group/view"));
const UGCreate = lazy(() => import("./components/user_group/create"));
const UGEdit = lazy(() => import("./components/user_group/edit"));
//e-form
const EFList = lazy(() => import("./components/e-form/list"));
const EFCreate = lazy(() => import("./components/e-form/create"));
const EFEdit = lazy(() => import("./components/e-form/edit"));
const EFOpen = lazy(() => import("./components/e-form/open"));
const EFReview = lazy(() => import("./components/e-form/review"));
const EFForm = lazy(() => import("./components/e-form/form"));
const EFFormUpdate = lazy(() => import("./components/e-form/form_update"));
const EFFormReview = lazy(() => import("./components/e-form/form_review"));

function App() {
  return (
    <Suspense fallback={<Loading />}>
      <FlashAlert />
      {/* <LoadingDisplay /> */}
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="sign-in" element={<SignIn />} />
          <Route path="setup" element={<Setup />} />
          <Route path="/" element={<RequireAuth><PageContainer /></RequireAuth>} />
          <Route path='/home' element={<Home />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/user'>
            <Route index element={<UList />} />
            <Route path=':id' element={<UView />} />
            <Route path='create' element={<UCreate />} />
            <Route path='edit/:id' element={<UEdit />} />
          </Route>
          <Route path='/outlet'>
            <Route index element={<OLList />} />
            <Route path=':id' element={<OLView />} />
            <Route path='create' element={<OLCreate />} />
            <Route path='edit/:id' element={<OLEdit />} />
          </Route>
          <Route path='/user-group'>
            <Route index element={<UGList />} />
            <Route path=':id' element={<UGView />} />
            <Route path='create' element={<UGCreate />} />
            <Route path='edit/:id' element={<UGEdit />} />
          </Route>
          <Route path='/category/:parent_id' element={<Category />} />
          <Route path='/company'>
            <Route index element={<CoyList />} />
            <Route path=':id' element={<CoyView />} />
            <Route path='create' element={<CoyCreate />} />
            <Route path='edit/:id' element={<CoyEdit />} />
          </Route>
          <Route path='/settings' element={<Settings />} />
          <Route path='e-form'>
            <Route index element={<EFList />} />
            <Route path="create" element={<EFCreate />} />
            <Route path=":id" element={<EFEdit />} />
            <Route path='open'>
              <Route path=":form_id" element={<EFOpen />} />
              <Route path="create/:form_id" element={<EFForm />} />
              <Route path="update/:record_id" element={<EFFormUpdate />} />
            </Route>
            <Route path='review'>
              <Route index element={<EFReview />} />
              <Route path=":form_id" element={<EFReview />} />
              <Route path="update/:record_id" element={<EFFormReview />} />
            </Route>
          </Route>
          <Route path='/profile'>
            <Route index element={<PList />} />
            <Route path=':id' element={<PView />} />
            <Route path='create' element={<PCreate />} />
            <Route path='edit/:id' element={<PEdit />} />
          </Route>
          <Route path='/file-manager'>
            <Route index element={<FileManager />} />
            <Route path='post-copy' element={<FileManager postMsg={true} />} />
          </Route>
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
